import type { LinkedinPost } from '../../entities/linkedinPost/linkedinPostTypes';
import { MOCK_GROUP_ID } from './mockSite';

/**
 * Dataset mock per LinkedinPost. Audit allineato a mockCalls/mockNotes (userId 1
 * = "Jader Francia"). activityDate distribuite su piu' mesi per popolare la
 * timeline. Il message è HTML (come prodotto dal RichTextEditor).
 *
 * Le Relationship LinkedinPost <-> Person/Business sono in relationshipMocks.ts.
 */
const baseAudit = { companyId: 1, groupId: MOCK_GROUP_ID, userId: 1, userName: 'Jader Francia' };
const auditAt = (iso: string) => ({ ...baseAudit, createDate: iso, modifiedDate: iso });

export const mockLinkedinPosts: LinkedinPost[] = [
  {
    linkedinPostId: 1,
    activityDate: '2026-04-12T10:00:00Z',
    message:
      '<p>Ciao Michele, ho visto il tuo post sul nuovo progetto di Acme Corp: complimenti! Mi piacerebbe approfondire una possibile collaborazione.</p>',
    ...auditAt('2026-04-12T10:00:00Z'),
  },
  {
    linkedinPostId: 2,
    activityDate: '2026-03-20T15:30:00Z',
    message:
      '<p>Buongiorno Elena, grazie per il collegamento. Le scrivo per presentarle la nostra soluzione per la gestione dei preventivi.</p>',
    ...auditAt('2026-03-20T15:30:00Z'),
  },
  {
    linkedinPostId: 3,
    activityDate: '2026-02-14T09:15:00Z',
    message:
      '<p>Salve, ho notato che la vostra azienda è in forte crescita. Sarei felice di mostrarvi come il nostro CRM può supportare il vostro team commerciale.</p>',
    ...auditAt('2026-02-14T09:15:00Z'),
  },
];
